import * as d3 from 'd3-selection'

export default function (selection, dimensions) {
  selection.each(function (data) {
    var text = d3.select(this)
                 .selectAll('text.gantt-task-text')
                 .data(d => {
                   // Determine if we have space for this label.
                   var hidden = d3.select(this)
                                  .append('text')
                                  .text(d.statusLabel)
                     , size = hidden.node().getComputedTextLength()

                   hidden.remove()

                   if (size + (dimensions.text.padding.right * 2) < d._gantt.foregroundWidth) {
                     return [{
                       text: d.statusLabel,
                       x: d.percentComplete ? (d._gantt.foregroundWidth + d._gantt.x - dimensions.text.padding.right) : (d._gantt.width / 2) ,
                       align: d.percentComplete ? 'end' : 'middle'
                     }]
                   } else {
                     return []
                   }
                 })

    text.exit().remove()

    text.enter()
        .append('text')
        .attr('class', 'gantt-task-text')
        .merge(text)
        .text(d => d.text)
        .attr('transform', d => `translate(${d.x}, ${dimensions.margin.top + dimensions.text.padding.top})`)
        .attr('text-anchor', d => d.align)
  })
}
